module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAGBAMAAADwPukCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA9QTFRF5eXl7Ozs8/Pz+vr6////0QRStAAAAA9JREFUCNdjYGAQYIJABgABtABJdgfnIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/jquery.uniform/dist/images/default/bg-input.png
// module id = ../../../../jquery.uniform/dist/images/default/bg-input.png
// module chunks = styles